import React, { useState, useEffect } from "react";
import Table from "react-bootstrap/Table";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import { FaEdit, FaEye, FaFileExcel, FaTrash } from "react-icons/fa";
import axios from "axios";
import Swal from "sweetalert2";
import "./Enquiry.css";

// const API_URL = "http://localhost:8000/enquiry.php";
const API_URL = "https://crm.fazoacademy.in/php/enquiry.php";


const today = new Date().toISOString().split('T')[0];

function Enquiry({ onLogout, role }) {
  const [courses, setCourses] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectEnquiry, setSelectEnquiry] = useState(null);
  const [viewshowModal, setViewShowModal] = useState(false);

  // const [newCourse, setNewCourse] = useState("");
  // const [newshortcourse, setNewshortcourse] = useState("");
  // const [amount, setAmount] = useState("");
  const [editCourse, setEditCourse] = useState({
    id: null,
    name: "",
    email: "",
    phone: "",
    date: "",
    // fees: "",
    notes: "",
    enquiry_details: "",
    yop: "",
    apply_by: "",
    fres_expre: "",
    carrer_gap: "",
    switch_job: "",
    location: ""
  });
  const [searchQuery, setSearchQuery] = useState("");
  const [deleteCourseId, setDeleteCourseId] = useState(null);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    date: today,
    // fees: "",
    notes: "",
    enquiry: "",
    yop: "",
    apply_by: "",
    fre_expr: "",
    carrer_gap: "",
    switch_job: "",
    location: ""

  })
  // Pagination States
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  // const [highlightedRowId, setHighlightedRowId] = useState(null);



  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value
    }));
  };


  // Fetch Courses from API
  const fetchCourses = async () => {
    try {
      const response = await axios.get(API_URL);
      console.log("Raw API Response:", response.data);
      const jsonString = response.data.substring(response.data.indexOf("["));
      const parsedData = JSON.parse(jsonString);
      setCourses(Array.isArray(parsedData) ? parsedData : []);
    } catch (error) {
      console.error("Error fetching courses:", error);
      setCourses([]);
    }
  };

  useEffect(() => {
    fetchCourses();
  }, []);

  const handleAddCourse = async () => {
    const trimmedName = formData.name.trim();
    const trimmedEmail = formData.email.trim();
    const trimmedPhone = formData.phone.trim();
    const trimmedDate = formData.date.trim();
    const trimmedNotes = formData.notes.trim();
    const trimmedEnquiry = formData.enquiry_details.trim();
    const trimmedApplyBy = role === 'user_1' ? 'Gayathri' :
      role === 'user_2' ? 'Lino' :
        formData.apply_by.trim();
    const trimmedYop = formData.yop.trim();
    const trimmedCarrerGap = formData.carrer_gap.trim();
    const trimmedfresexpre = formData.fre_expr.trim();
    const trimmedSwitchcarrer = formData.switch_job.trim();
    const trimmedLocation = formData.location.trim();

    if (
      !trimmedName ||
      !trimmedPhone ||
      !trimmedDate ||
      !trimmedNotes ||
      !trimmedEnquiry ||
      !trimmedApplyBy ||
      !trimmedYop ||
      !trimmedCarrerGap ||
      !trimmedfresexpre ||
      !trimmedSwitchcarrer ||
      !trimmedLocation
    ) {
      Swal.fire({
        icon: "warning",
        title: "Field EMPTY",
        text: "Please fill all the fields",
      });
      return;
    }

    
if (courses.some(enquiry => enquiry.phone === trimmedPhone)) {
  Swal.fire({
    icon: "error",
    title: "Duplicate Phone",
    text: "This phone number is already registered!",
  });
  return;
}

    try {
      await axios.post(API_URL, {
        name: trimmedName,
        email: trimmedEmail,
        phone: trimmedPhone,
        date: trimmedDate,
        notes: trimmedNotes,
        enquiry_details: trimmedEnquiry,
        apply_by: trimmedApplyBy,
        yop: trimmedYop,
        carrer_gap: trimmedCarrerGap,
        switch_job: trimmedSwitchcarrer,
        fre_expr: trimmedfresexpre,
        location: trimmedLocation,
      });

      fetchCourses();
      setFormData({
        name: "",
        email: "",
        phone: "",
        date: today,
        notes: "",
        enquiry_details: "",
        apply_by: "",
        yop: "",
        carrer_gap: "",
        switch_job: "",
        fre_expr: "",
        location: ""
      });

      setShowModal(false);

      Swal.fire({
        icon: "success",
        title: "Success!",
        text: "Course added successfully!",
        showConfirmButton: false,
        timer: 2000,
      });
    } catch (error) {
      console.error("Error adding course:", error);
      Swal.fire({
        icon: "error",
        title: "Oops!",
        text: "Failed to add course.",
      });
    }
  };

  // edit model 
  const handleEditCourse = async () => {
const trimmedName = editCourse.name?.trim() || "";
const trimmedEmail = editCourse.email?.trim() || "";
const trimmedPhone = editCourse.phone?.trim() || "";
const trimmedDate = editCourse.date?.trim() || "";
const trimmedNotes = editCourse.notes?.trim() || "";
const trimmedEnquiry = editCourse.enquiry_details?.trim() || "";
const trimmedApplyBy =
  role === "user_1"
    ? "Gayathri"
    : role === "user_2"
    ? "Lino"
    : formData.apply_by?.trim() || "";

const trimmedYop = editCourse.yop?.trim() || "";
const trimmedCarrerGap = editCourse.carrer_gap?.trim() || "";
const trimmedfresexpre = editCourse.fres_expre?.trim() || "";
const trimmedSwitchcarrer = editCourse.switch_job?.trim() || "";
const trimmedLocation = editCourse.location?.trim() || "";

    if (
      !trimmedName ||
      !trimmedEmail ||
      !trimmedPhone ||
    
      !trimmedNotes ||
      // !trimmedEnquiry ||
      // !trimmedApplyBy ||
      !trimmedYop ||
      !trimmedCarrerGap ||
      !trimmedfresexpre ||
      // !trimmedSwitchcarrer ||
      !trimmedLocation
    ) {
      Swal.fire({
        icon: "warning",
        title: "Field EMPTY",
        text: "Please fill all the fields",
      });
      return;
    }


    try {
      await axios.put(`${API_URL}/${editCourse.id}`, editCourse); // Include course ID
      // setHighlightedRowId(id);
      fetchCourses();
      setShowEditModal(false);
      Swal.fire({
        icon: "success",
        title: "Updated!",
        text: "Course updated successfully!",
        showConfirmButton: false,
        timer: 2000,
      });
    } catch (error) {
      console.error("Error updating course:", error);
      Swal.fire({ icon: "error", title: "Oops!", text: "Failed to update course." });
    }

  };

  //delete data
  const handleDeleteCourse = async (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await axios.delete(`${API_URL}?id=${id}`); // Correct API Call
          fetchCourses(); // Refresh data after deletion

          Swal.fire({
            icon: "success",
            title: "Deleted!",
            text: "Course has been deleted successfully.",
            showConfirmButton: false,
            timer: 2000,
          });
        } catch (error) {
          console.error("Error deleting course:", error);
          Swal.fire({
            icon: "error",
            title: "Oops!",
            text: "Failed to delete course. Please try again.",
          });
        }
      }
    });
  };


  //search 
const filteredCourses = courses.filter(course => {
  const q = (searchQuery || '').toLowerCase();

  return (
    String(course.name || '').toLowerCase().includes(q) ||
    String(course.email || '').toLowerCase().includes(q) ||
    String(course.phone || '').toLowerCase().includes(q) ||
    String(course.enquiry || '').toLowerCase().includes(q) ||
    String(course.yop || '').toLowerCase().includes(q) ||
    String(course.apply_by || '').toLowerCase().includes(q) ||
    String(course.fre_expr || course.fres_expre || '').toLowerCase().includes(q) || // ✅ fix typo mismatch
    String(course.date || '').toLowerCase().includes(q) ||
    String(course.location || '').toLowerCase().includes(q) ||
    String(course.notes || '').toLowerCase().includes(q)
  );
});


  // Pagination Logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentCourses = filteredCourses.slice(indexOfFirstItem, indexOfLastItem);

  const handleExportToExcel = () => {
    window.open(`${API_URL}?export=excel`, "_blank");
  };

  const handleViewDetail = (courses) => {
    setSelectEnquiry(courses);
    setViewShowModal(true);

  }



  return (
    <div className="course-container">
      <div className="navigation">
        <a href="#">Enquiry Form</a> / <a href="#" onClick={onLogout}>Logout</a>
      </div>

      <div className="add-course">
        <button onClick={() => setShowModal(true)} className="add-btn">
          Add Details
        </button>
      </div>

      <div className="d-flex justify-content-between">


        <Form.Select
          value={itemsPerPage}
          onChange={(e) => setItemsPerPage(Number(e.target.value))}
          className="pagination-select"
        >
          <option value="10">Show 10</option>
          <option value="20">Show 20</option>
          <option value="30">Show 30</option>
        </Form.Select>

        <div className="search-container">
          <Form.Control
            type="text"
            placeholder="Search "
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="search-input"
          />
        </div>

        <Button onClick={handleExportToExcel} className="excel-btn">
          <FaFileExcel className="excel-icon" /> Export to Excel
        </Button>

      </div>


      <Table striped bordered hover className="course-table">
        <thead>
          <tr>
            <th>S.No</th>
            <th>Name</th>
            <th>Email Id</th>
            <th>Phone</th>
            <th>Location</th>
            <th>Date</th>
            <th>Enquiry</th>
            {/* <th>YOP</th> */}
            {/* <th>Enquiry</th>
            <th>Refernce</th>
            <th>Gap</th>
            <th>Fres/Expre</th>
            <th>Switch To</th> */}
            <th>Notes</th>
            {/* {role === 'admin' && <th>Action</th>} */}
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {
            currentCourses.filter(course => course.status === "Active").length === 0 ? (
              <tr>
                <td colSpan={role === 'admin' ? 15 : 14} className="text-center text-danger">
                  No details found
                </td>
              </tr>
            ) : (
              currentCourses
                .filter(course => course.status === "Active")
                .map((course, index) => (
                  <tr
                    key={course.id}
                    className={`
              ${course.apply_by?.toLowerCase() === "gayathri" ? "table-secondary" : ""}
              ${course.apply_by?.toLowerCase() === "lino" ? "table-warning" : ""}
            `}
                  >
                    <td>{indexOfFirstItem + index + 1}</td>
                    <td>{course.name}</td>
                    <td>{course.email}</td>
                    <td>{course.phone}</td>
                    <td>{course.location}</td>
                    <td>{course.date}</td>
                    <td>{course.enquiry}</td>
                 
                    {/* <td>{course.yop}</td>
                    <td>{course.enquiry}</td>
                    <td>{course.apply_by}</td>
                    <td>{course.carrer_gap}</td>
                    <td>{course.fres_expre}</td>
                    <td>{course.switch_carrer}</td> */}
                    <td>{course.notes}</td>
                    <td>
                      {role === 'admin' && (
                        <>
                          <FaEdit
                            className="edit-icon"
                            onClick={() => {
                              setEditCourse(course);
                              setShowEditModal(true);
                            }}
                          />
                          <FaTrash
                            className="delete-icon"
                            onClick={() => handleDeleteCourse(course.id)}
                          />
                          &nbsp;
                        </>
                      )}
                      <FaEye
                        className="view-icon"
                        onClick={() => handleViewDetail(course)}
                      />
                    </td>
                  </tr>
                ))
            )}
        </tbody>

      </Table>

      {/* Pagination Controls */}
      <div className="pagination-controls">
        <Button
          variant="secondary"
          onClick={() => setCurrentPage(currentPage - 1)}
          disabled={currentPage === 1}
        >
          Previous
        </Button>
        <span className="page-number">Page {currentPage}</span>
        <Button
          variant="secondary"
          onClick={() => setCurrentPage(currentPage + 1)}
          disabled={indexOfLastItem >= filteredCourses.length}
        >
          Next
        </Button>
      </div>

      {/* Modals */}
      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Add Course</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group as={Row} className="mb-3" controlId="formName">
              <Form.Label column sm={3}>Name</Form.Label>
              <Col sm={9}>
                <Form.Control
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Enter name"
                />
              </Col>
            </Form.Group>

            <Form.Group as={Row} className="mb-3" controlId="formEmail">
              <Form.Label column sm={3}>Email</Form.Label>
              <Col sm={9}>
                <Form.Control
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Enter email"
                />
              </Col>
            </Form.Group>

            <Form.Group as={Row} className="mb-3" controlId="formPhone">
              <Form.Label column sm={3}>Phone</Form.Label>
              <Col sm={9}>
                <Form.Control
                  type="text"
                  value={formData.phone}
                  onChange={(e) => {
                    const input = e.target.value;
                    if (/^\d{0,10}$/.test(input)) {
                      handleChange({ target: { name: 'phone', value: input } });
                    }
                  }}
                  placeholder="Enter Mobile Number"
                  required
                />
                {formData.phone.length > 0 && formData.phone.length !== 10 && (
                  <div style={{ color: 'red', marginTop: '5px' }}>
                    Enter Valid Phone Number.
                  </div>
                )}
              </Col>
            </Form.Group>

            <Form.Group as={Row} className="mb-3" controlId="formName">
              <Form.Label column sm={3}>Location</Form.Label>
              <Col sm={9}>
                <Form.Control
                  type="text"
                  name="location"
                  value={formData.location}
                  onChange={handleChange}
                  placeholder="Enter location"
                />
              </Col>
            </Form.Group>


            <Form.Group as={Row} className="mb-3" controlId="formDate">
              <Form.Label column sm={3}>Date</Form.Label>
              <Col sm={9}>
                <Form.Control
                  type="date"
                  name="date"
                  value={formData.date}
                  onChange={handleChange}
                />
              </Col>
            </Form.Group>
            {/* 
            <Form.Group as={Row} className="mb-3" controlId="formFees">
              <Form.Label column sm={3}>Fees</Form.Label>
              <Col sm={9}>
                <Form.Control
                  type="hidden"
                  name="fees"
                  value={formData.fees}
                  onChange={(e) => {
                    const input = e.target.value;
                    if (/^\d{0,6}$/.test(input)) {
                      handleChange({ target: { name: 'fees', value: input } });
                    }
                  }}
                  placeholder="Enter fees"
                />
              </Col>
            </Form.Group> */}

            <Form.Group as={Row} className="mb-3" controlId="formEnquiry">
              <Form.Label column sm={3}>Enquiry For</Form.Label>
              <Col sm={9}>
                <Form.Control
                  as="select"
                  name="enquiry_details"
                  value={formData.enquiry_details}
                  onChange={handleChange}
                >
                  <option value="">Select</option>
                  <option value="All">All</option>

                  <option value="PXY">PXY</option>
                  <option value="DOC">DOC</option>
                  <option value="IV-SUP">IV-SUP</option>
                  <option value="COURSE">COURSE</option>
                </Form.Control>
              </Col>
            </Form.Group>

            <Form.Group as={Row} className="mb-3" controlId="formYop">
              <Form.Label column sm={3}>YOP</Form.Label>
              <Col sm={9}>
                <Form.Control
                  type="text"
                  name="yop"
                  value={formData.yop}
                  onChange={(e) => {
                    const input = e.target.value;
                    if (/^\d{0,4}$/.test(input)) {
                      handleChange({ target: { name: 'yop', value: input } });
                    }
                  }}
                  placeholder="Enter Year of Passing"
                />
              </Col>
            </Form.Group>

            <Form.Group as={Row} className="mb-3" controlId="FormCarrerGap">
              <Form.Label column sm={3}>Career Gap</Form.Label>
              <Col sm={9}>
                <Form.Control
                  type="text"
                  name="carrer_gap"
                  value={formData.carrer_gap}
                  onChange={(e) => {
                    const input = e.target.value;
                    if (/^\d{0,2}(\.\d{0,2})?$/.test(input)) {
                      handleChange({ target: { name: 'carrer_gap', value: input } });
                    }
                  }}
                  placeholder="Enter Career Gap"
                />
              </Col>
            </Form.Group>

            <Form.Group as={Row} className="mb-3" controlId="formFresExpre">
              <Form.Label column sm={3}>Fresher/Exper</Form.Label>
              <Col sm={9}>
                <Form.Control
                  as="select"
                  name="fre_expr"
                  value={formData.fre_expr}
                  onChange={handleChange}
                >
                  <option value="">Select</option>
                  <option value="Fresher">Fresher</option>
                  <option value="Experience">Experience</option>
                </Form.Control>
              </Col>
            </Form.Group>

            <Form.Group as={Row} className="mb-3" controlId="formSwitch">
              <Form.Label column sm={3}>Switch Carrer</Form.Label>
              <Col sm={9}>
                <Form.Control
                  as="select"
                  name="switch_job"
                  value={formData.switch_job}
                  onChange={handleChange}
                >
                  <option value="">Select</option>
                  <option value="Non-IT to IT">Switch to Non-IT to IT</option>
                  <option value="IT Experience">IT Experience</option>
                  <option value="IT Fresher">IT Fresher</option>
                </Form.Control>
              </Col>
            </Form.Group>

            <Form.Group as={Row} className="mb-3" controlId="formNotes">
              <Form.Label column sm={3}>Notes</Form.Label>
              <Col sm={9}>
                <Form.Control
                  as="textarea"
                  rows={3}
                  name="notes"
                  value={formData.notes}
                  onChange={handleChange}
                  placeholder="Enter any notes"
                />
              </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3" controlId="formApply">
              <Form.Label column sm={3}>Apply By</Form.Label>
              <Col sm={9}>
                <Form.Control
                  as="select"
                  name="apply_by"
                  value={formData.apply_by}
                  onChange={handleChange}
                  disabled={role === 'user_1' || role === 'user_2'}
                >
                  <option value="">Select</option>
                  <option value="Gayathri">Gayathri</option>
                  <option value="Lino">Lino</option>
                </Form.Control>

                {/* Hidden input to ensure the value is submitted when disabled */}
                {(role === 'user_1' || role === 'user_2') && (
                  <input
                    type="hidden"
                    name="apply_by"
                    value={role === 'user_1' ? 'Gayathri' : 'Lino'}
                  />
                )}
              </Col>
            </Form.Group>




          </Form>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Cancel
          </Button>
          <Button variant="success" onClick={handleAddCourse}>
            Add Details
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showEditModal} onHide={() => setShowEditModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Edit Course</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group as={Row} className="mb-3" controlId="formName">
              <Form.Label column sm={3}>Name</Form.Label>
              <Col sm={9}>
                <Form.Control
                  type="text"
                  name="name"
                  value={editCourse.name}
                  onChange={(e) => setEditCourse({ ...editCourse, name: e.target.value })}


                />
              </Col>
            </Form.Group>

            <Form.Group as={Row} className="mb-3" controlId="formEmail">
              <Form.Label column sm={3}>Email</Form.Label>
              <Col sm={9}>
                <Form.Control
                  type="email"
                  name="email"
                  value={editCourse.email}
                  onChange={(e) => setEditCourse({ ...editCourse, email: e.target.value })}

                />
              </Col>
            </Form.Group>

            <Form.Group as={Row} className="mb-3" controlId="formPhone">
              <Form.Label column sm={3}>Phone</Form.Label>
              <Col sm={9}>
                <Form.Control
                  type="text"
                  value={editCourse.phone}
                  onChange={(e) => {
                    const input = e.target.value;
                    if (/^\d{0,10}$/.test(input)) {
                      setEditCourse({ ...editCourse, phone: e.target.value });
                    }
                  }}
                  placeholder="Enter Mobile Number"
                  required
                />
                {formData.phone.length > 0 && formData.phone.length !== 10 && (
                  <div style={{ color: 'red', marginTop: '5px' }}>
                    Enter Valid Phone Number.
                  </div>
                )}
              </Col>
            </Form.Group>

            <Form.Group as={Row} className="mb-3" controlId="formName">
              <Form.Label column sm={3}>Location</Form.Label>
              <Col sm={9}>
                <Form.Control
                  type="text"
                  name="name"
                  value={editCourse.location}
                  onChange={(e) => setEditCourse({ ...editCourse, location: e.target.value })}


                />
              </Col>
            </Form.Group>


            <Form.Group as={Row} className="mb-3" controlId="formDate">
              <Form.Label column sm={3}>Date</Form.Label>
              <Col sm={9}>
                <Form.Control
                  type="date"
                  name="date"
                  value={editCourse.date}
                  onChange={(e) => setEditCourse({ ...editCourse, date: e.target.value })}
                />
              </Col>
            </Form.Group>
            {/* 
            <Form.Group as={Row} className="mb-3" controlId="formFees">
              <Form.Label column sm={3}>Fees</Form.Label>
              <Col sm={9}>
                <Form.Control
                  type="hidden"
                  name="fees"
                  value={editCourse.fees}
                  onChange={(e) => {
                    const input = e.target.value;
                    if (/^\d{0,6}$/.test(input)) {
                      setEditCourse({ ...editCourse, fees: e.target.value })
                    }


                  }}
                  placeholder="Enter fees"
                />
              </Col>
            </Form.Group>
 */}

            <Form.Group as={Row} className="mb-3" controlId="formEnquiry">
              <Form.Label column sm={3}>Enquiry For</Form.Label>
              <Col sm={9}>
                <Form.Control
                  as="select"
                  name="enquiry_details"
                  value={editCourse.enquiry}
                  onChange={(e) => setEditCourse({ ...editCourse, enquiry: e.target.value })}
                  required
                >
                  <option value="">Select</option>
                  <option value="All">All</option>
                  <option value="PXY">PXY</option>
                  <option value="DOC">DOC</option>
                  <option value="IV-SUP">IV-SUP</option>
                  <option value="COURSE">COURSE</option>
                  <option value = "INTERNSHIP">INTERNSHIP</option>
                </Form.Control>
              </Col>
            </Form.Group>

            <Form.Group as={Row} className="mb-3" controlId="formYop">
              <Form.Label column sm={3}>YOP</Form.Label>
              <Col sm={9}>
                <Form.Control
                  type="text"
                  name="yop"
                  value={editCourse.yop}
                  onChange={(e) => {
                    const input = e.target.value;
                    if (/^\d{0,4}$/.test(input)) {
                      setEditCourse({ ...editCourse, yop: e.target.value })
                    }

                  }}

                />
              </Col>
            </Form.Group>

            <Form.Group as={Row} className="mb-3" controlId="FormCarrerGap">
              <Form.Label column sm={3}>Career Gap</Form.Label>
              <Col sm={9}>
                <Form.Control
                  type="text"
                  name="carrer_gap"
                  value={editCourse.carrer_gap}
                  onChange={(e) => {
                    const input = e.target.value;
                    if (/^\d{0,2}(\.\d{0,2})?$/.test(input)) {
                      setEditCourse({ ...editCourse, carrer_gap: e.target.value })
                    }
                  }}

                />
              </Col>
            </Form.Group>

            <Form.Group as={Row} className="mb-3" controlId="formFresExpre">
              <Form.Label column sm={3}>Fresher/Exper</Form.Label>
              <Col sm={9}>
                <Form.Control
                  as="select"
                  name="fre_expr"
                  value={editCourse.fres_expre}
                  onChange={(e) => {
                    setEditCourse({ ...editCourse, fres_expre: e.target.value })
                  }}>

                  <option value="">Select</option>
                  <option value="Fresher">Fresher</option>
                  <option value="Experience">Experience</option>
                </Form.Control>
              </Col>
            </Form.Group>

            <Form.Group as={Row} className="mb-3" controlId="formSwitch">
              <Form.Label column sm={3}>Switch Carrer</Form.Label>
              <Col sm={9}>
                <Form.Control
                  as="select"
                  name="switch_job"

                  value={editCourse.switch_carrer}
                  onChange={(e) => {
                    setEditCourse({ ...editCourse, switch_carrer: e.target.value })
                  }}>

                  <option value="">Select</option>
                  <option value="Non-IT to IT">Switch to Non-IT to IT</option>
                  <option value="IT Experience">IT Experience</option>
                  <option value="IT Fresher">IT Fresher</option>
                </Form.Control>
              </Col>
            </Form.Group>

            <Form.Group as={Row} className="mb-3" controlId="formNotes">
              <Form.Label column sm={3}>Notes</Form.Label>
              <Col sm={9}>
                <Form.Control
                  as="textarea"
                  rows={3}
                  name="notes"
                  value={editCourse.notes}
                  onChange={(e) => {
                    setEditCourse({ ...editCourse, notes: e.target.value })
                  }} />

              </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3" controlId="formApply">
              <Form.Label column sm={3}>Apply By</Form.Label>
              <Col sm={9}>
                <Form.Control
                  as="select"
                  name="apply_by"
                  value={editCourse.apply_by}
                  onChange={(e) => {
                    setEditCourse({ ...editCourse, apply_by: e.target.value })
                  }}
                >
                  <option value="">Select</option>
                  <option value="Gayathri">Gayathri</option>
                  <option value="Lino">Lino</option>
                </Form.Control>
              </Col>
            </Form.Group>


          </Form>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowEditModal(false)}>
            Cancel
          </Button>
          <Button variant="success" onClick={handleEditCourse}>
            Update Enquiry
          </Button>
        </Modal.Footer>
      </Modal>


      <Modal show={viewshowModal} onHide={() => setViewShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Enquiry Details</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {selectEnquiry && (
            <>
              <p><strong>Name:</strong> {selectEnquiry.name}</p>
              <p><strong>Email Id:</strong> {selectEnquiry.email}</p>
              <p><strong>Phone:</strong> {selectEnquiry.phone}</p>
              <p><strong>Location:</strong> {selectEnquiry.location}</p>
              <p><strong>Date:</strong> {selectEnquiry.date}</p>
              <p><strong>YOP:</strong> {selectEnquiry.yop}</p>
              <p><strong>Enquiry:</strong> {selectEnquiry.enquiry}</p>
              <p><strong>Reference:</strong> {selectEnquiry.apply_by}</p>
              <p><strong>Gap:</strong> {selectEnquiry.carrer_gap}</p>
              <p><strong>Fresher/Experienced:</strong> {selectEnquiry.fres_expre}</p>
              <p><strong>Switch To:</strong> {selectEnquiry.switch_carrer}</p>
              <p><strong>Notes:</strong> {selectEnquiry.notes}</p>
            </>
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setViewShowModal(false)}>
            OK
          </Button>
        </Modal.Footer>
      </Modal>

    </div>
  );
}

export default Enquiry;
